<template>
  
  <div>

    <div class="ui large breadcrumb">
      <router-link to="/products/reserves" class="section">
        <i class="reply icon m-r-5"></i>Reservas
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <i class="info circle icon"></i> {{ reserveId }}
      </div>
      <span v-if="reserve" class="animated fadeIn">
        <i class="right chevron icon divider"></i>
        <div class="section">
          <span v-if="reserve.isWaiting"><i class="clock yellow icon"></i> Pendente</span>
          <span v-if="reserve.isConfirmed"><i class="check circle green icon"></i> Confirmada</span>
          <span v-if="reserve.isExpired"><i class="exclamation circle icon"></i> Expirada</span>
          <span v-if="reserve.isCanceled"><i class="times red icon"></i> Cancelada</span>
        </div>
      </span>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else class="ui grid animated fadeIn">

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div id="info-segment" class="ui segment">
          <h4 class="ui dividing header">Dados da Reserva</h4>
          <form class="ui form">
            <div class="fields">
              <div class="three wide field">
                <label class="form-label">Número</label>
                <span>{{ reserve.id }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">Emissão</label>
                <span>{{ $formatDate(reserve.date) }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">Data Validade</label>
                <span class="red bold text">{{ $formatDate(reserve.dateValid) }}</span>
              </div>
              <div class="five wide field">
                <label class="form-label">Hora Validade</label>
                <span class="red bold text">{{ reserve.timeValid }}</span>
              </div>
            </div>
            <div v-if="reserve.idQuotation" class="fields">
              <div class="three wide field">
                <label class="form-label">Orçamento</label>
                <span>{{ reserve.idQuotation }}</span>
              </div>
              <div class="ten wide field">
                <label class="form-label">Item Orçamento</label>
                <span>{{ reserve.itemQuotation }}</span>
              </div>
            </div>
          </form>  
        </div>
      </div>  

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div id="owner-segment" class="ui segment">
          <h4 class="ui dividing header">Responsável</h4>
          <form class="ui form">
            <div class="fields">
              <div class="two wide field">
                <label class="form-label">Código</label>
                <span>{{ user.id }}</span>
              </div>
              <div class="six wide field">
                <label class="form-label">Grupo</label>
                <span>{{ user.groupName }}</span>
              </div>
              <div class="eight wide field">
                <label class="form-label">Nome</label>
                <span>{{ user.name +  ' ' + user.lastName }}</span>
              </div>              
            </div>
          </form>  
        </div>
      </div>

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui segment">
          <h4 class="ui dividing header">Produto</h4>
          <form class="ui form">
            <div class="fields">
              <div v-if="!$isCustomerOrProspect()" class="three wide field">
                <label class="form-label">Unidade</label>
                <span>{{ reserve.balance.branch.name }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">Código</label>
                <span>{{ reserve.balance.product.code }}</span>
              </div>          
              <div class="nine wide field">
                <label class="form-label">Descrição</label>
                <span>{{ reserve.balance.product.description }}</span>
              </div>                         
            </div>
            <div class="fields">
              <div class="three wide field">
                <label class="form-label">Bitola</label>
                <span>{{ reserve.balance.product.bitola }}</span>                
              </div>
              <div class="four wide field">
                <label class="form-label">Cor</label>
                <span>{{ reserve.balance.product.color }}</span>
              </div>
              <div class="nine wide field">
                <label class="form-label">Acondicionamento</label>
                <span>{{ reserve.balance.address }}</span>
              </div>
            </div>
            <div class="fields">
              <div class="three wide field">
                <label class="form-label">Quantidade</label>
                <span>{{ $formatInteger(reserve.balance.quantity) }}</span>
              </div>
              <div class="ten wide field">
                <label class="form-label">Total</label>
                <span>{{ $formatInteger(reserve.balance.total) }}</span>
              </div>
            </div>
          </form>  
        </div>
      </div>

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui segment">
          <h4 class="ui dividing header">Cliente</h4>
          <form class="ui form">            
            <div class="fields">
              <div class="three wide field">
                <label class="form-label">Código</label>
                <span>{{ customer.code + '-' + customer.unit }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">CNPJ</label>
                <span>{{ customer.formatCnpj }}</span>
              </div>
              <div class="nine wide field">
                <label class="form-label">Razão Social</label>
                <span>{{ customer.name }}</span>
              </div>              
            </div>
            <div class="fields">
              <div class="sixteen wide field">
                <label class="form-label">Endereço</label>
                <span>{{ customerAddress }}</span>
              </div>
            </div>
            <div class="fields">
              <div class="four wide field">
                <label class="form-label">Telefone</label>
                <span>{{ customer.ddd + ' ' + customer.phone }}</span>
              </div>  
              <div class="twelve wide field">
                <label class="form-label">E-mail</label>
                <span>{{ customer.email}}</span>
              </div>              
            </div>
          </form>  
        </div>
      </div>
      
      <div class="sixteen wide column">
        <button class="ui basic button" @click="onExit()">
          <i class="reply icon"></i> Sair
        </button>
        <button v-if="showCancelButton" class="ui basic red right floated button" @click="onCancel()">
          <i class="times icon"></i> Cancelar
        </button>
      </div>  

    </div> 

    <div id="cancel-reserve-dialog" class="ui tiny modal cancel-reserve-modal">
      <div class="ui header">
        Cancelamento de Reserva de Produto
      </div>
      <div class="content">
        <p>Confirma cancelamento da reserva <strong>{{ reserveId }}</strong> ?</p>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="remove icon"></i>
          Não
        </button>
        <button class="ui red basic button" :class="{ loading: canceling }" @click="onConfirmCancel()">
          <i class="checkmark icon"></i>
          Sim
        </button>
      </div>
    </div> 

  </div>

</template>

<script>

  import Message from "@/utils/message"
  import { CustomerService, UserService, OppBalanceService } from "@/services"

  export default {
    
    data() {
      return {
        loading: true,
        canceling: false,
        branchId: "",
        reserveId: "",
        reserve: null,
        user: null,
        customer: null,
      }
    },

    computed: {

      customerAddress() {
        return CustomerService.customerAddress(this.customer)        
      },

      showCancelButton() {
        
        if (!this.reserve)
          return false

        const isSeller = this.$store.state.user.isSeller  
        const isOwner = (this.$store.state.user.id == this.reserve.userId)        

        return this.reserve.isWaiting && !(isSeller && !isOwner)
      },
    },

    created() {

      this.branchId = this.$route.params.branch
      this.reserveId = this.$route.params.id

      this.loadReserve()
    },

    beforeDestroy() {
      $(".cancel-reserve-modal").remove()
    },

    methods: {

      async loadReserve() {

        this.loading = true

        try {

          this.reserve = await OppBalanceService.getReserveById(this.branchId, this.reserveId)
          this.user = await UserService.getById(this.reserve.userId)
          this.customer = await CustomerService.getByCode(this.reserve.customerCode, this.reserve.customerUnit)

          const isOwner = (this.$store.state.user.id == this.reserve.userId)

          if (this.$isCustomer() && !isOwner)
            this.$router.push("/not-found")

          this.loading = false    
          
          if (this.reserve.idQuotation) {
            setTimeout(() => $("#owner-segment").height($("#info-segment").height()), 300)
          }          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onExit() {
        this.$router.push("/products/reserves")
      },

      onCancel() {
        $("#cancel-reserve-dialog").modal("show")
      },

      async onConfirmCancel() {

        if (this.canceling)
          return

        this.canceling = true  

        try {

          await OppBalanceService.cancel(this.branchId, this.reserveId)

          this.setReserveCanceled(this.reserve)  
          this.setAsCanceledInStore()

          $("#cancel-reserve-dialog").modal("hide")

          this.canceling = false

          Message.success("Reserva cancelada com sucesso")          
          
        } catch (error) {
          
          this.canceling = false

          this.$errorHandler(error)
        }
      },

      setAsCanceledInStore() {

        if (!this.$store.state.reserves)
          return

        let newReserves = []
        let reserves = this.$store.state.reserves.slice()   
        let filter = this.$store.state.reservesFilter       

        reserves.forEach((reserve) => {

          if (reserve.balance.branch.id == this.branchId && reserve.id == this.reserveId)
            this.setReserveCanceled(reserve)          

          if (!filter.status || reserve.status == filter.status)
            newReserves.push(reserve)
        })

        this.$store.commit("setReserves", newReserves)
      },

      setReserveCanceled(reserve) {
        
        reserve.status = OppBalanceService.RESERVE_STATUS.CANCELED
        reserve.isWaiting = false          
        reserve.isCanceled = true
      }
    },
  }

</script>

